if (!window.Eurus.loadedScript.has('video-shopping.js')) {
  window.Eurus.loadedScript.add('video-shopping.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVideoShopping', (sectionId) => ({
        showSlideListItemInVideoCard: false,
        showSlideProductInPopup: false,
        showSlideProductInVideoCard: false,
        showPopup: false,
        productSelectedId: '',
        positionBottomGroupAnnouncementAndHeader: 0,
        isMobile: false,
        init() {
          document.addEventListener(`eurus:${sectionId}:shoppable-video-popup-close`, () => {
            this.showSlideProductInVideoCard = false;
            this.showSlideListItemInVideoCard = false
          });
        },
        openProductInPopup(productId) {
          this.showSlideProductInPopup = true
          this.productSelectedId = productId;
        },
        openProductInSlide(productId) {
          this.showSlideProductInVideoCard = true
          this.productSelectedId = productId
        },
        closeProductInSlide() {
          this.isOpenProductInPopupMobile = false
          this.showSlideProductInVideoCard = false
          setTimeout(() => {
            this.productSelectedId = ''
          }, 500)
        },
        closeProductInPopup() {
          this.showSlideProductInPopup = false
          setTimeout(() => {
            this.productSelectedId = ''
          }, 500)
        },
        openPopup() {
          this.showPopup = true
          Alpine.store('xPopup').openVideoShopping = true
          const announcement = document.getElementById("x-announcement")
          const header = document.getElementById("x-header-container")
          if (announcement) {
            if (announcement.dataset.isSticky == 'true') {
              if (header && header.offsetHeight + header.getBoundingClientRect().top > announcement.offsetHeight) {
                this.positionBottomGroupAnnouncementAndHeader = header ? header.offsetHeight + header.getBoundingClientRect().top : 0;
              }
              else {
                this.positionBottomGroupAnnouncementAndHeader = announcement.offsetHeight;
              }
            }
            else {
              this.positionBottomGroupAnnouncementAndHeader = header ? header.offsetHeight + header.getBoundingClientRect().top : announcement.offsetHeight + announcement.getBoundingClientRect().top
            }
          }
          else {
            this.positionBottomGroupAnnouncementAndHeader = header ? header.offsetHeight + header.getBoundingClientRect().top : 0
          }
          if ((!header || header?.getBoundingClientRect().bottom < 0) && (!announcement || announcement?.getBoundingClientRect().bottom < 0)) {
            this.positionBottomGroupAnnouncementAndHeader = 0;
          }
        },
        closePopup() {
          this.showPopup = false
          setTimeout(() => {
            Alpine.store('xPopup').openVideoShopping = false
          }, 500)
          this.closeProductInPopup()
        },
        // b7 Pause other videos on hover 기능을 위해 추가
handleVideoHover(isEnter, currentSlide) {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover || !currentSlide) return;

  const sectionRoot = currentSlide.closest('.x-container-video-shopping');
  const list = currentSlide.closest('.splide__list');
  if (!sectionRoot || !list) return;

  const pauseOtherVideos = sectionRoot.dataset.pauseOtherVideosOnHover === 'true';
  const blurOtherSlides = sectionRoot.dataset.overlayOtherSlidesOnHover === 'true';
  const slides = list.querySelectorAll('.splide__slide, .grid-item');

  if (blurOtherSlides) {
    list.classList.add('is-hovering-slide');
  }

  slides.forEach((slide) => {
    const isCurrent = slide === currentSlide;
    const videoContainer = slide.querySelector('.b7-video-container');

    slide.classList.toggle('is-hover-active', blurOtherSlides && isCurrent);
    slide.classList.toggle('is-hover-muted', blurOtherSlides && !isCurrent);

    if (!pauseOtherVideos || !videoContainer) return;

    if (isCurrent) {
      Alpine.store('xVideo')?.play(videoContainer);
    } else {
      Alpine.store('xVideo')?.pause(videoContainer);
    }
  });
},

resetVideoShoppingHover(target) {
  const list = target?.closest?.('.splide__list') || target;
  if (!list) return;

  list.classList.remove('is-hovering-slide');

  list.querySelectorAll('.splide__slide, .grid-item').forEach((slide) => {
    slide.classList.remove('is-hover-muted', 'is-hover-active');

    const videoContainer = slide.querySelector('.b7-video-container');
    if (videoContainer) {
      Alpine.store('xVideo')?.play(videoContainer);
    }
  });
}

      }))
    })
  })
}